import React from 'react';
import { getCustomFormValue } from "../../../Helpers/CustomFormHelper";

const CustomFormValueCell = (props) => {

    if (props.row.isDateRow || props.row.isFilterRow) {
        return null;
    }

    const getValue = () => {
        return getCustomFormValue(props.formField, props.row.form);
    }

    return (
        <>
            {getValue()}
        </>
    )
}

export default CustomFormValueCell;
